import { CommonBonus } from '.'

export enum SocialTaskBonusEnums {
  ConnectTelegram = 'TELEGRAMCONNECT',
  VerifyEmailForWeb3User = 'EMAILVERIFY',
}

export type SocialTaskBonus = {
  code: SocialTaskBonusEnums
  description: string
  isCompleted: boolean
  bonus: CommonBonus
}
